export default __webpack_public_path__ + "static/media/canada.7070a166.jpg";